import React from "react";

import styles from "./NewPagination.module.scss";

export const NewPagination = ({
  resultsCount = 0,
  pageIndex = 0,
  pageOptions,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  serverPageCount = null
}) => {
  return (
    <div className={styles.base}>
      <div className={styles.paginationContainer}>
        <span className={styles.searchResultsCount}>
          {resultsCount} Results
        </span>
        <span className={styles.pageDisplay}>
          Displaying Page {resultsCount ? pageIndex + 1 : pageIndex} of{" "}
          {serverPageCount !== null ? serverPageCount : pageOptions.length}
        </span>
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className={styles.paginationButton}
        >
          Previous
        </button>
        <button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          className={styles.paginationButton}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default NewPagination;
